import { FieldError, useFormContext, useFormState } from "react-hook-form";

import { useRateContext } from "../Context/RateContext";
import { useRateFieldName } from "./useRateFieldName";

import { RateData } from "@/features/LiveFormEditor/Steps/StepTickets/Rates/types";
import { StepTicketsFormData } from "@/features/LiveFormEditor/Steps/StepTickets/types";

export const useRateFieldError = <K extends keyof RateData>(field: K): FieldError | undefined => {
  const { rateIndex } = useRateContext();
  const { control } = useFormContext<StepTicketsFormData>();
  const name = useRateFieldName(field);
  const { errors } = useFormState({ control, name });

  return errors?.rates?.[rateIndex]?.[field] as FieldError | undefined;
};
